export const SET_LOGGED_IN_USER: string = 'SET_LOGGED_IN_USER';
